/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TraceMaterial } from '../../models/trace-material';

export interface GetTraceMaterialAssignedForProductionOrder$Params {
  workCenterId: number;
  productionOrderId: number;
}

export function getTraceMaterialAssignedForProductionOrder(http: HttpClient, rootUrl: string, params: GetTraceMaterialAssignedForProductionOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<TraceMaterial>> {
  const rb = new RequestBuilder(rootUrl, getTraceMaterialAssignedForProductionOrder.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TraceMaterial>;
    })
  );
}

getTraceMaterialAssignedForProductionOrder.PATH = '/api/v1/TraceMaterial/{workCenterId}/productionOrders/{productionOrderId}';
